import { coerceBooleanProperty } from "@angular/cdk/coercion";

export function coerceBoolean() {
	return (target: any, key: string) => {
		Object.defineProperty(target, key, {
			get() {
				return this[`_${key}`];
			},
			set(value) {
				this[`_${key}`] = coerceBooleanProperty(value);
			},
		});
	};
}
